import FilterValues from "./filtervalues.js";
import SelectedFilters from "./selectedfilters.js";
import UpdateFilterUrl from "./updatefilterurl.js";
import noUiSlider from "../../../thirdparty/nouislider/nouislider.js";
import { prodListValues } from './shared.js';

const mobileFilterDropDown = document.getElementById('filterDropDown');

class PriceRangeFilter {
    constructor() {
        this.priceMinimum = null;
        this.priceMaximum = null;
        this.priceRange = null;
        this.slider = null;
        this.priceMin = null;
        this.priceMax = null;
        this.apply = null;
        this.sliderStep = null;
    }

    initVars() {
        this.priceMinimum = parseFloat(document.getElementById('PriceMinOriginal').value);
        this.priceMaximum = parseFloat(document.getElementById('PriceMaxOriginal').value);
        this.priceRange = document.getElementById('PriceRange');
        this.slider = document.getElementById('price-range');
        this.priceMin = document.getElementById('PriceMin');
        this.priceMax = document.getElementById('PriceMax');
        this.apply = document.getElementById('filterPriceApply');
        this.sliderStep = .01;
    };

    init() {
        this.initVars();

        // throws an error with ui slider when the values are the same
        if (this.priceMinimum !== this.priceMaximum) {
            this.setupPriceSlider();
        }
        this.parsePrice();
        this.events();
    };

    setupPriceSlider() {
        noUiSlider.create(this.slider, {
            start: [this.priceMinimum, this.priceMaximum],
            connect: true,
            animate: true,
            range: {
                'min': this.priceMinimum,
                'max': this.priceMaximum,
            },
            step: this.sliderStep,
        });

        if (this.slider) {
            var sliderValues = this.slider.noUiSlider.get();
            this.priceMin.value = Number.parseFloat(sliderValues[0]).toFixed(2);
            this.priceMax.value = Number.parseFloat(sliderValues[1]).toFixed(2);
        }
    };

    events() {
        if (this.slider.noUiSlider) {
            this.slider.noUiSlider.on('update', (values, handle) => {
                if (handle) {
                    this.priceMax.value = values[handle];
                } else {
                    this.priceMin.value = values[handle];
                }
            });
        }
        this.priceMin.addEventListener('blur', () => {
            const min = parseFloat(this.priceMin.value);

            if (!isNaN(min)) {
                var max = this.priceMax.value;

                if (min < this.priceMinimum) {
                    this.priceMin.value = this.priceMinimum;
                }
                if (min > parseFloat(max)) {
                    this.priceMin.value = max;
                }
                if (this.slider.noUiSlider) {
                    this.slider.noUiSlider.set([this.priceMin.value, null]);
                }
            } else {
                this.priceMin.value = this.priceMinimum;
            }
        });
        this.priceMax.addEventListener('blur', () => {
            const max = parseFloat(this.priceMax.value);
            if (!isNaN(max)) {
                const min = this.priceMin.value;

                if (max > this.priceMaximum) {
                    this.priceMax.value = this.priceMaximum;
                }

                if (parseFloat(min) > max) {
                    this.priceMax.value = min;
                }
                if (this.slider.noUiSlider) {
                    this.slider.noUiSlider.set([null, this.priceMax.value]);
                }
            } else {
                this.priceMax.value = this.priceMaximum;
            }
        });
        this.apply.addEventListener('click', (e) => {
            e.preventDefault();

            var min = parseFloat(this.priceMin.value);
            var max = parseFloat(this.priceMax.value);

            // validating user input
            if (isNaN(min) || isNaN(max) || min > max) {
                this.priceMin.value = this.priceMinimum;
                this.priceMax.value = this.priceMaximum;
                return;
            }

            this.add(true);

            if (mobileFilterDropDown.classList.contains('active')) {
                mobileFilterDropDown.click();
            }
        });
    };

    parsePrice() {
        this.priceMin.value = this.priceMinimum.toFixed(2);
        this.priceMax.value = this.priceMaximum.toFixed(2);
    };

    add(logFilter) {
        const filterName = document.getElementById('PriceFilterTitle').value.replace('##PRICELOW##', this.priceMin.value).replace('##PRICEHIGH##', this.priceMax.value);

        FilterValues.removePriceRangeFilter();
        SelectedFilters.removeFromSelectedFilter(this.priceRange);
        FilterValues.addPriceRangeFilter(this.apply.id, this.priceMin.value, this.priceMax.value, logFilter);
        SelectedFilters.addToSelectedFilter(this.priceRange, filterName);

        // should be false if url already contains filter
        if (logFilter) {
            UpdateFilterUrl.update(FilterValues, prodListValues, false);
        }
    };

    update(min, max, addFilter) {
        if (typeof this.slider !== 'undefined' && this.slider && (min != max)) {
            this.slider.noUiSlider.set([min.toFixed(2), max.toFixed(2)]);
        }

        addFilter = addFilter || addFilter === undefined;

        if (addFilter) {
            this.add(false);
        }
    };

    clear() {
        FilterValues.removePriceRangeFilter();
        SelectedFilters.removeFromSelectedFilter(this.priceRange);
        if (typeof this.slider !== 'undefined' && this.slider && (this.priceMinimum != this.priceMaximum)) {
            this.slider.noUiSlider.set([this.priceMinimum.toFixed(2), this.priceMaximum.toFixed(2)]);
        }
    };
}

export default new PriceRangeFilter();